var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArrowUpOutline = function SvgArrowUpOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.368 3.26a.9.9 0 011.264 0l7.1 7a.9.9 0 01-1.264 1.28L12.9 6.052V20.1a.9.9 0 11-1.8 0V6.051l-5.568 5.49a.9.9 0 01-1.264-1.282l7.1-7z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjM2ODEgMy4yNTkxMUMxMS43MTg1IDIuOTEzNjMgMTIuMjgxNSAyLjkxMzYzIDEyLjYzMTkgMy4yNTkxMUwxOS43MzE5IDEwLjI1OTFDMjAuMDg1OCAxMC42MDgxIDIwLjA4OTkgMTEuMTc3OSAxOS43NDA5IDExLjUzMTlDMTkuMzkxOSAxMS44ODU4IDE4LjgyMjEgMTEuODg5OSAxOC40NjgxIDExLjU0MDlMMTIuOSA2LjA1MTE4VjIwLjFDMTIuOSAyMC41OTcxIDEyLjQ5NzEgMjEgMTIgMjFDMTEuNTAyOSAyMSAxMS4xIDIwLjU5NzEgMTEuMSAyMC4xVjYuMDUxMTlMNS41MzE4NyAxMS41NDA5QzUuMTc3OTEgMTEuODg5OSA0LjYwODA4IDExLjg4NTggNC4yNTkxMSAxMS41MzE5QzMuOTEwMTQgMTEuMTc3OSAzLjkxNDE4IDEwLjYwODEgNC4yNjgxMyAxMC4yNTkxTDExLjM2ODEgMy4yNTkxMVoiIGZpbGw9IiMwMjNGODAiLz4KPC9zdmc+Cg==";
export { SvgArrowUpOutline as ReactComponent };